export default __webpack_public_path__ + "static/media/avatar_ig_en.0732b0cb.png";